import create, { UseStore } from 'zustand';

const defaultConfigUri = '/config.json';

export type Config = {
  codingUrl: string;
  codeSetsUrl: string;
  documentsUrl: string;
  socketUrl: string;
  messagingUrl: string;
  codingAppUrl: string;
  dataAdminAppUrl: string;
  homeAppUrl?:string;
  reportingAppUrl?:string;s
  systemUser?: string;
  auth: {
    //aws
    region: string;
    userPoolId: string;
    userPoolWebClientId: string;
    authenticationFlowType: string;
    mfa?: boolean;
    //okta
    clientId?: string;
    issuer?: string;
    redirectUri?: string;
  };
  version?: string;
};

const configKey = '__dhconf';
function setConfig(a: Config) {
  localStorage.setItem(configKey, JSON.stringify(a));
}
function getConfig(): Config {
  return JSON.parse(localStorage.getItem(configKey));
}

export let config: Config = null;

export async function loadConfig(url?:string): Promise<Config> {
  console.log('Loading Config....', url);

  function save(a: Config) {
    if (a) {
      config = a;
      configApi.setState({ config });
      setConfig(config);
    }
    return Promise.resolve(config);
  }

  if (config?.codingUrl) {
    return save(config);
  }

  try {
    const json: Config = await fetch(
      (url || defaultConfigUri) + `?${new Date().getTime()}`,
      { cache: 'no-cache' }
    )
      .then((response) => (response.ok ? response : Promise.reject(response)))
      .then((response) => response.json());
    return save({ ...json });
  } catch (error) {
    config = getConfig();
    console.error('Config file could not be loaded', error, config);
    return save(config);
  }
}

type ConfigApi = {
  config: Config;
};

function createConfigApi(): UseStore<ConfigApi> {
  return create<ConfigApi>(() => ({
    config: null,
  }));
}
export const configApi = createConfigApi();
